// Per-language <title> and meta description content.
// The static index.html has Hungarian defaults; this hook updates them
// client-side when the user switches language.

const SEO_BY_LANG = {
  hu: {
    title: "Klímatisztítás Balatonszemes · A-team · Klímamosás Balaton déli part",
    description:
      "Professzionális klímatisztítás Balatonszemesen és a Balaton déli partján. Online időpontfoglalás.",
  },
  en: {
    title: "AC Cleaning Balatonszemes · A-team · Lake Balaton south shore",
    description:
      "Professional air conditioner cleaning in Balatonszemes and around Lake Balaton. Online booking. Call: +36 70 577 8151",
  },
  de: {
    title: "Klimaanlagen-Reinigung Balatonszemes · A-team · Plattensee Südufer",
    description:
      "Professionelle Klimaanlagen-Reinigung in Balatonszemes und am Südufer des Plattensees. Online Termin. Anruf: +36 70 577 8151",
  },
  nl: {
    title: "Airco-reiniging Balatonszemes · A-team · Balatonmeer zuidkust",
    description:
      "Professionele airco-reiniging in Balatonszemes en aan de zuidkust van het Balatonmeer. Online afspraak. Bel: +36 70 577 8151",
  },
};

const OG_LOCALE = {
  hu: "hu_HU",
  en: "en_GB",
  de: "de_DE",
  nl: "nl_NL",
};

function setMeta(selector, value) {
  const el = document.querySelector(selector);
  if (el && value) el.setAttribute("content", value);
}

export function applyLangSeo(lang) {
  const config = SEO_BY_LANG[lang] || SEO_BY_LANG.hu;
  document.title = config.title;
  setMeta('meta[name="description"]', config.description);
  setMeta('meta[property="og:title"]', config.title);
  setMeta('meta[property="og:description"]', config.description);
  setMeta('meta[property="og:locale"]', OG_LOCALE[lang] || OG_LOCALE.hu);
  setMeta('meta[name="twitter:title"]', config.title);
  setMeta('meta[name="twitter:description"]', config.description);
}
